import type { AgentType } from '@/services/chatApi';

interface AgentSelectorProps {
  selectedAgent: AgentType;
  onAgentChange: (agent: AgentType) => void;
  disabled?: boolean;
}

export function AgentSelector({ selectedAgent, onAgentChange, disabled }: AgentSelectorProps) {
  return (
    <div className="flex items-center gap-2 px-3 py-1.5">
      <label className="text-sm text-dark-400">Agent:</label>
      <select
        value={selectedAgent}
        onChange={(e) => onAgentChange(e.target.value as AgentType)}
        disabled={disabled}
        className="text-sm border border-dark-600/50 rounded px-2 py-1 bg-dark-800/80 text-dark-100 disabled:opacity-50 focus:border-primary-500/50 focus:outline-none focus:ring-1 focus:ring-primary-500/30"
        aria-label="Select agent"
      >
        <option value="analyst">Analyst</option>
        <option value="clearing">Clearing</option>
      </select>
    </div>
  );
}
